export default "__VITE_ASSET__CY2Ech15__"